// extracted by mini-css-extract-plugin
export var cardLayout = "_6x-1";
export var paginationContainer = "_6x-0";